import { jsx } from 'react/jsx-runtime';
import Typography from '@material-ui/core/Typography';
import { apiDocsConfigRef } from '../../config.esm.js';
import { useApi } from '@backstage/core-plugin-api';

const ApiTypeTitle = (props) => {
  const { apiEntity } = props;
  const config = useApi(apiDocsConfigRef);
  const definition = config.getApiDefinitionWidget(apiEntity);
  const type = definition ? definition.title : apiEntity.spec.type;
  return /* @__PURE__ */ jsx(Typography, { component: "span", variant: "inherit", children: type });
};

export { ApiTypeTitle };
//# sourceMappingURL=ApiTypeTitle.esm.js.map
